import styled from 'styled-components'
import { Typography, rem } from '~theme'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const IconButton = styled.button`
  padding: 0;
  font-size: ${rem(32)};
  color: inherit;
`

export const Month = styled.h2`
  ${Typography.titleMedium};
`
